import { toast } from "react-toastify";
import { axiosInstance } from "../../Utils/AxiosInstance";

// In your action file
export const GetAllNotificationNew = (data, pageNumber = 1) => {
  return {
    type: "get_allNotification_new",
    payload: data,
    pageNumber,
    loader: false,
  };
};

export function getallNotificationsNew(PageNumber = 1, PageSize = 10) {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `/Notifications/GetAllNotifications?PageNumber=${PageNumber}&PageSize=${PageSize}`,
      );

      if (response?.data?.IsSuccess === true) {
        dispatch(
          GetAllNotificationNew(
            {
              data: response.data.Data.data,
              pagination: {
                pageNumber: response.data.Data.PageNumber,
                pageSize: response.data.Data.PageSize,
                totalPages: response.data.Data.TotalPages,
                totalRecords: response.data.Data.TotalRecords,
                unreadCount: response.data.Data.UnreadCount,
                nextPage: response.data.Data.NextPage,
                previousPage: response.data.Data.PreviousPage,
              },
              message: response.data.Message,
              success: response.data.IsSuccess,
            },
            PageNumber,
          ),
        );
      } else {
        toast.error(response?.data?.Message || "Something went wrong");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("getallNotificationsNew error:", error);
    }
  };
}
